import API from "../../utilities/LocalApiProxy";
import { uploadFileRequest } from "../documentActions";
import { FILE_UPLOAD_FAILURES, UPDATE_REACT_DIALOG_CONTENT } from "../types";
import { createFilesUploadingContentForDialog } from "../../components/reactDialog";
import { FILE_UPLOAD_LIMITS } from "./constants";

export async function createDocumentAndFolderRecords(
	fileList,
	chunkSize,
	i,
	files,
	fileIdMap,
	dispatch
) {
	return API.post("/bulk/documentsWithFolders/import", {
		body: {
			documentList: fileList,
		},
	})
		.then(async (result) => {
			let firstNewDocumentID = result.mysql.firstNewDocumentID;

			let fileListForPresignedUrls = await fileList.map((file, j) => {
				let fileIndex = chunkSize * i + j;
				let originalFile = files[fileIndex];
				const newDocumentId = firstNewDocumentID + j;
				fileIdMap[newDocumentId] = {
					id: newDocumentId,
					originalFile,
					name: file.lxwFilenameWithExtension,
					size: file.size,
					folder: file.original.LXW_FOLDER,
				};
				return {
					id: newDocumentId,
					contentType: originalFile.type,
					mtime: originalFile.lastModified,
				};
			});
			// browsers can only make so many requests simultaneously this will limit the number of active signedUrls
			const uploadToS3ChunkSize = FILE_UPLOAD_LIMITS.S3_UPLOAD_CHUNK_SIZE;
			let chunkedFileListForPresignedUrls = chunkArray(
				fileListForPresignedUrls,
				uploadToS3ChunkSize
			);

			for (let k = 0; k < chunkedFileListForPresignedUrls.length; k++) {
				const fileToUploadToS3 = chunkedFileListForPresignedUrls[k];
				let fileCount = files.length;
				let fileCounter = i * chunkSize + k * uploadToS3ChunkSize;
				await bulkGetSignedUrls(
					fileToUploadToS3,
					fileIdMap,
					fileCounter,
					fileCount,
					uploadToS3ChunkSize,
					dispatch
				).catch((err) => {
					return Promise.reject(err);
				});
			}
		})
		.catch(() => {
			console.error("catching err, adding files to failedList", fileList);
			dispatch({
				type: FILE_UPLOAD_FAILURES,
				payload: { bulkUploadFilesFailed: fileList },
			});
		});
}

export async function bulkGetSignedUrls(
	filesToUploadToS3,
	fileIdMap,
	fileCounter,
	fileCount,
	uploadToS3ChunkSize,
	dispatch
) {
	return API.post("/bulk/multipleSignedUrlForDocumentUpload", {
		body: {
			documents: filesToUploadToS3,
			uploadSource: "web",
		},
	})
		.then((res) => {
			let signedUrls = res.mysql.urls;
			let fileNameArray = filesToUploadToS3.map(
				(f) => fileIdMap[f.id].name
			);

			let maxFile = fileCounter + uploadToS3ChunkSize;
			dispatch({
				type: UPDATE_REACT_DIALOG_CONTENT,
				payload: {
					counter: fileCounter,
					loading: false,
					mainContent: createFilesUploadingContentForDialog(
						fileNameArray,
						`Uploading files ${fileCounter + 1}-${
							maxFile > fileCount ? fileCount : maxFile
						} of ${fileCount} files:`
					),
				},
			});

			let promises = signedUrls.map((r) => {
				let myOriginalFile = fileIdMap[r.documentID];
				return uploadToS3(
					// failed files added to global list
					r.url,
					myOriginalFile,
					r.documentID,
					myOriginalFile.size,
					dispatch
				);
			});

			// ensures all promises resolve/reject before moving onto the next batch
			return Promise.allSettled(promises).then((results) => {
				const versionData = results
					.filter((r) => r.status === "fulfilled")
					.map((r) => r.value);

				if (versionData.length > 0) {
					return insertVersionRecords(versionData);
				}
			});
		})
		.catch(() => {
			let bulkUploadFilesFailed = filesToUploadToS3.map((f) => {
				let myFile = fileIdMap[f.id].originalFile;
				return {
					documentID: f.id,
					lxwFilenameWithExtension: myFile.name,
					original: {
						LXW_FOLDER: myFile.path
							? myFile.path
							: myFile.webkitRelativePath,
					},
				};
			});
			dispatch({
				type: FILE_UPLOAD_FAILURES,
				payload: { bulkUploadFilesFailed },
			});
		});
}

export async function uploadToS3(
	url,
	myOriginalFile,
	documentID,
	fileSize,
	dispatch
) {
	let file = myOriginalFile.originalFile;

	return uploadFileRequest(url, file)
		.then((res) => {
			return {
				documentID: documentID,
				versionID: res.headers["x-amz-version-id"],
				filesize: fileSize,
				mtime: file.lastModified,
			};
		})
		.catch((err) => {
			// add files for if uploadFileRequest fails
			dispatch({
				type: FILE_UPLOAD_FAILURES,
				payload: {
					bulkUploadFilesFailed: [
						{
							documentID,
							lxwFilenameWithExtension: file.name,
							original: {
								LXW_FOLDER: file.path
									? file.path
									: file.webkitRelativePath,
							},
						},
					],
				},
			});
			return Promise.reject(err);
		});
}

function insertVersionRecords(versionData) {
	return API.put("/document/version", {
		body: { versionData },
	});
}

function chunkArray(arr, len) {
	var chunks = [],
		i = 0,
		n = arr.length;

	while (i < n) {
		chunks.push(arr.slice(i, (i += len)));
	}

	return chunks;
}
